/**
 * The API workspace last open in each project, per device (owner, 21.10.2026:
 * a project holds several workspaces; picking the project reopens the one you
 * were in). A small map in localStorage, `{ [projectId]: workspaceId }`.
 */
const KEY = 'apiboo.projectScope.lastWorkspace.v1';

function read() {
  try {
    const raw = JSON.parse(window.localStorage.getItem(KEY) || '{}');
    return raw && typeof raw === 'object' && !Array.isArray(raw) ? raw : {};
  } catch {
    return {};
  }
}

export function lastWorkspaceFor(projectId) {
  if (projectId == null) return null;
  const id = read()[String(projectId)];
  return id == null ? null : String(id);
}

export function rememberWorkspace(projectId, workspaceId) {
  if (projectId == null || workspaceId == null) return;
  const map = read();
  if (map[String(projectId)] === String(workspaceId)) return;
  map[String(projectId)] = String(workspaceId);
  try {
    window.localStorage.setItem(KEY, JSON.stringify(map));
  } catch {
    // Storage unavailable: the project opens its first workspace instead.
  }
}
